export default "__VITE_ASSET__DrDH7B1e__"